import React from 'react';
import PropTypes from 'prop-types';

import TrackingProgress from 'components/account/TrackingProgress';
import OrderItemImage from 'components/account/OrderItemImage';
import MelodyCarousel from 'components/common/MelodyCarousel';

const RecentOrder = ({ order }, { testId }) => {
  const { orderId, lineItems } = order;
  return (
    <div>
      <MelodyCarousel title="Your Recently Placed Order">
        {lineItems.map(({ product }, index) => {
          const { retinaImageUrl, name } = product;
          return (
            <OrderItemImage
              key={index}
              data-test-id={testId('recentlyPlacedOrder')}
              title={name}
              imageUrl={retinaImageUrl}
              url={`/orders/${orderId}`}/>
          );
        })}
      </MelodyCarousel>
      <TrackingProgress order={order}/>
    </div>
  );
};

RecentOrder.propTypes = {
  order: PropTypes.object.isRequired
};

RecentOrder.contextTypes = {
  testId: PropTypes.func
};

export default RecentOrder;
